// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.queueManagmentContainer {
    display: flex;
    align-items: center;
    flex-direction: column;
    direction: rtl;
    background-color: #f1f7ff;
    height: 100vh;

}

.actionOfPatientContainer {
    display: flex;


}


.moveToRoomBtnMain {
    margin: 10px;
    background-image: linear-gradient(to right, #4ca0f9 0%, #3762f0 51%, #368cdc 100%);
    background-size: 200% auto;
    border-radius: 10px;
    padding: 5px;
    width: 130px;
    font-size: 10pt;
    text-align: center;
    font-weight: 500;
    color: #ffffff;
    border: none;
}



.patientDetail {
    background-color: #f1f7ff;
    padding: 10px;
    text-align: center;
    font-weight: 500;
    display: flex;
    border-radius: 10px;
    margin-bottom: 15px;
    flex-direction: column;
    width: 200px;
    align-items: center;
    justify-content: center;
    /* box-shadow: 0px 0px 20px 0px #e8e8e8; */
}

.finishTreatmentMain {
    background-color: white;
    margin: 10px;
    padding: 10px;
    border-radius: 10px;
    border: none;
    color: red;
    width: 100px;
    height: 80px;
}

.detailTitleContainer {

    display: flex;
}


.detailProperty {
    background-color: #ffffff;
    color: #396af1;
    width: 100%;
    border-radius: 10px;
    padding: 3px;
    margin: 7px;
}

.detailTitle {
    margin-left: 5px;
}

.patientsDetailsTableContainer,
.roomsDetailsTableContainer {
    background-color: #ffffff;
    padding: 0px 40px 40px 40px;
    border-radius: 8px;
    margin: 40px;
    width: 73%;
    margin-top: 120px;


}

.patientsDetailsTableCont {
    display: flex;
    justify-content: center;
    align-items: center;

}

.operationContainer {
    display: flex;
    align-items: center;
    background-color: white;
    border-radius: 10px;
    margin-top: 20px;
    box-shadow: 0px 1px 8px 1px #efefef;
    justify-content: center;
    flex-direction: row;

}

.moreOperationCont {
       align-items: center;
       background-color: white;
       box-shadow: 0px 1px 8px 1px #efefef;
       justify-content: flex-start;
       padding: 10px;
       justify-content: flex-start;
     

}

.tableAndOperationCont {
    display: flex;
    flex-direction: row-reverse;
    margin-right: 30px;


}

.patientDetailsContainer {
    margin-left: 20px;
}


/* ---------------------------------------------------------------------------------- */


.moreOperation {
    border-radius: 100px;
    background-color: white;
    border: 1px solid #f03737;
    margin: 10px;

    padding: 5px;
    width: 150px;
    font-size: 10pt;
    text-align: center;
    font-weight: 500;
}

.moreOperation:hover {
    background-color: rgb(255, 234, 234);

}

.managmentTitle {
    font-weight: 700;
    margin-bottom: 50px;
    border-bottom-left-radius: 100px;
    border-bottom-right-radius: 100px;
    background-image: linear-gradient(to right, #4ca0f9 0%, #3762f0 51%, #368cdc 100%);
    background-size: 200% auto;
    color: white;
    width: 20%;
    padding: 8px;

}

.tabs {
    display: flex;
    cursor: pointer;
    margin-bottom: 10px;
}

.managementTitle {
    font-weight: 700;
    margin-bottom: 50px;
    border-bottom-left-radius: 100px;
    border-bottom-right-radius: 100px;
    color: white;
    width: 20%;
    padding: 8px;
    background-color: lightgray;
    transition: background-color 0.3s ease;
    margin-left: 10px;
}

.managementTitle.active {
    font-weight: 700;
    margin-bottom: 50px;
    border-bottom-left-radius: 100px;
    border-bottom-right-radius: 100px;
    background-image: linear-gradient(to right, #4ca0f9 0%, #3762f0 51%, #368cdc 100%);
    background-size: 200% auto;
    color: white;
    width: 20%;
    padding: 8px;
    margin-left: 10px;

}

.managementTitle:hover {
    font-weight: 700;
    margin-bottom: 50px;
    border-bottom-left-radius: 100px;
    border-bottom-right-radius: 100px;
    background-image: linear-gradient(to right, #b0d4fb 0%, #819df6 51%, #78b4ec 100%);
    background-size: 200% auto;
    color: white;
    width: 20%;
    margin-left: 10px;

    padding: 8px;
}

.endDayBtn{
    padding: 10px;
    border-radius: 100px;
    margin: 20px;
    width: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #3145f2;
    background-color: #eaf0ff;
    color: #3145f2;
    font-size: 12pt;
    font-weight: 600;
}




.anotherButtons {
    box-shadow: -3px 2px 0px 0px #e85656;
    width: 50px;
    height: 50px;
    border-radius: 12px;
    background-color: rgb(255 245 245);
    border: none;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition-duration: 0.3s;
    overflow: hidden;
    position: relative;
    margin: 10px;
    color: red;
}

.svgIcon {
    width: 12px;
    transition-duration: 0.3s;
}

.svgIcon path {
    fill: rgb(255, 16, 16);
}

.anotherButtons:hover {
    width: 140px;
    border-radius: 12px;
    transition-duration: 0.3s;
    background-color: rgb(255, 0, 0);
    align-items: center;
    color: white;
    box-shadow: none;

}

.anotherButtons:hover .svgIcon {
    /* width: 20px; */
    transition-duration: 0.3s;
    transform: translateY(-200%);
}

.addPatientManual::before {
    position: absolute;
    bottom: -20px;
    content: "הוספת מטופל";
    color: white;
    font-size: 0px;
}


.anotherButtons:hover::before {
    font-size: 13px;
    opacity: 1;
    bottom: unset;
    transition-duration: 0.3s;
}
.no-patients-message{
    margin: 20px;
    background-color: white;
    box-shadow: 3px 2px 9px 0px rgb(222 222 222);
    padding: 20px;
    border-radius: 20px;
    display: flex;
    align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/components/QueuesManagment/QueuesManagmentPage.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;IACd,yBAAyB;IACzB,aAAa;;AAEjB;;AAEA;IACI,aAAa;;;AAGjB;;;AAGA;IACI,YAAY;IACZ,kFAAkF;IAClF,0BAA0B;IAC1B,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,YAAY;AAChB;;;;AAIA;IACI,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,0CAA0C;AAC9C;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,YAAY;AAChB;;AAEA;;IAEI,aAAa;AACjB;;;AAGA;IACI,yBAAyB;IACzB,cAAc;IACd,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,yBAAyB;IACzB,2BAA2B;IAC3B,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,iBAAiB;;;AAGrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;AAEvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,mCAAmC;IACnC,uBAAuB;IACvB,mBAAmB;;AAEvB;;AAEA;OACO,mBAAmB;OACnB,uBAAuB;OACvB,mCAAmC;OACnC,2BAA2B;OAC3B,aAAa;OACb,2BAA2B;;;AAGlC;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,kBAAkB;;;AAGtB;;AAEA;IACI,iBAAiB;AACrB;;;AAGA,uFAAuF;;;AAGvF;IACI,oBAAoB;IACpB,uBAAuB;IACvB,yBAAyB;IACzB,YAAY;;IAEZ,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;;AAExC;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gCAAgC;IAChC,iCAAiC;IACjC,kFAAkF;IAClF,0BAA0B;IAC1B,YAAY;IACZ,UAAU;IACV,YAAY;;AAEhB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gCAAgC;IAChC,iCAAiC;IACjC,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,2BAA2B;IAC3B,sCAAsC;IACtC,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gCAAgC;IAChC,iCAAiC;IACjC,kFAAkF;IAClF,0BAA0B;IAC1B,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,iBAAiB;;AAErB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gCAAgC;IAChC,iCAAiC;IACjC,kFAAkF;IAClF,0BAA0B;IAC1B,YAAY;IACZ,UAAU;IACV,iBAAiB;;IAEjB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;;;;AAKA;IACI,oCAAoC;IACpC,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kCAAkC;IAClC,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,gCAAgC;IAChC,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;;AAEpB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,cAAc;AAClB;;;AAGA;IACI,eAAe;IACf,UAAU;IACV,aAAa;IACb,yBAAyB;AAC7B;AACA;IACI,YAAY;IACZ,uBAAuB;IACvB,4CAA4C;IAC5C,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB","sourcesContent":[".queueManagmentContainer {\r\n    display: flex;\r\n    align-items: center;\r\n    flex-direction: column;\r\n    direction: rtl;\r\n    background-color: #f1f7ff;\r\n    height: 100vh;\r\n\r\n}\r\n\r\n.actionOfPatientContainer {\r\n    display: flex;\r\n\r\n\r\n}\r\n\r\n\r\n.moveToRoomBtnMain {\r\n    margin: 10px;\r\n    background-image: linear-gradient(to right, #4ca0f9 0%, #3762f0 51%, #368cdc 100%);\r\n    background-size: 200% auto;\r\n    border-radius: 10px;\r\n    padding: 5px;\r\n    width: 130px;\r\n    font-size: 10pt;\r\n    text-align: center;\r\n    font-weight: 500;\r\n    color: #ffffff;\r\n    border: none;\r\n}\r\n\r\n\r\n\r\n.patientDetail {\r\n    background-color: #f1f7ff;\r\n    padding: 10px;\r\n    text-align: center;\r\n    font-weight: 500;\r\n    display: flex;\r\n    border-radius: 10px;\r\n    margin-bottom: 15px;\r\n    flex-direction: column;\r\n    width: 200px;\r\n    align-items: center;\r\n    justify-content: center;\r\n    /* box-shadow: 0px 0px 20px 0px #e8e8e8; */\r\n}\r\n\r\n.finishTreatmentMain {\r\n    background-color: white;\r\n    margin: 10px;\r\n    padding: 10px;\r\n    border-radius: 10px;\r\n    border: none;\r\n    color: red;\r\n    width: 100px;\r\n    height: 80px;\r\n}\r\n\r\n.detailTitleContainer {\r\n\r\n    display: flex;\r\n}\r\n\r\n\r\n.detailProperty {\r\n    background-color: #ffffff;\r\n    color: #396af1;\r\n    width: 100%;\r\n    border-radius: 10px;\r\n    padding: 3px;\r\n    margin: 7px;\r\n}\r\n\r\n.detailTitle {\r\n    margin-left: 5px;\r\n}\r\n\r\n.patientsDetailsTableContainer,\r\n.roomsDetailsTableContainer {\r\n    background-color: #ffffff;\r\n    padding: 0px 40px 40px 40px;\r\n    border-radius: 8px;\r\n    margin: 40px;\r\n    width: 73%;\r\n    margin-top: 120px;\r\n\r\n\r\n}\r\n\r\n.patientsDetailsTableCont {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n\r\n}\r\n\r\n.operationContainer {\r\n    display: flex;\r\n    align-items: center;\r\n    background-color: white;\r\n    border-radius: 10px;\r\n    margin-top: 20px;\r\n    box-shadow: 0px 1px 8px 1px #efefef;\r\n    justify-content: center;\r\n    flex-direction: row;\r\n\r\n}\r\n\r\n.moreOperationCont {\r\n       align-items: center;\r\n       background-color: white;\r\n       box-shadow: 0px 1px 8px 1px #efefef;\r\n       justify-content: flex-start;\r\n       padding: 10px;\r\n       justify-content: flex-start;\r\n     \r\n\r\n}\r\n\r\n.tableAndOperationCont {\r\n    display: flex;\r\n    flex-direction: row-reverse;\r\n    margin-right: 30px;\r\n\r\n\r\n}\r\n\r\n.patientDetailsContainer {\r\n    margin-left: 20px;\r\n}\r\n\r\n\r\n/* ---------------------------------------------------------------------------------- */\r\n\r\n\r\n.moreOperation {\r\n    border-radius: 100px;\r\n    background-color: white;\r\n    border: 1px solid #f03737;\r\n    margin: 10px;\r\n\r\n    padding: 5px;\r\n    width: 150px;\r\n    font-size: 10pt;\r\n    text-align: center;\r\n    font-weight: 500;\r\n}\r\n\r\n.moreOperation:hover {\r\n    background-color: rgb(255, 234, 234);\r\n\r\n}\r\n\r\n.managmentTitle {\r\n    font-weight: 700;\r\n    margin-bottom: 50px;\r\n    border-bottom-left-radius: 100px;\r\n    border-bottom-right-radius: 100px;\r\n    background-image: linear-gradient(to right, #4ca0f9 0%, #3762f0 51%, #368cdc 100%);\r\n    background-size: 200% auto;\r\n    color: white;\r\n    width: 20%;\r\n    padding: 8px;\r\n\r\n}\r\n\r\n.tabs {\r\n    display: flex;\r\n    cursor: pointer;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.managementTitle {\r\n    font-weight: 700;\r\n    margin-bottom: 50px;\r\n    border-bottom-left-radius: 100px;\r\n    border-bottom-right-radius: 100px;\r\n    color: white;\r\n    width: 20%;\r\n    padding: 8px;\r\n    background-color: lightgray;\r\n    transition: background-color 0.3s ease;\r\n    margin-left: 10px;\r\n}\r\n\r\n.managementTitle.active {\r\n    font-weight: 700;\r\n    margin-bottom: 50px;\r\n    border-bottom-left-radius: 100px;\r\n    border-bottom-right-radius: 100px;\r\n    background-image: linear-gradient(to right, #4ca0f9 0%, #3762f0 51%, #368cdc 100%);\r\n    background-size: 200% auto;\r\n    color: white;\r\n    width: 20%;\r\n    padding: 8px;\r\n    margin-left: 10px;\r\n\r\n}\r\n\r\n.managementTitle:hover {\r\n    font-weight: 700;\r\n    margin-bottom: 50px;\r\n    border-bottom-left-radius: 100px;\r\n    border-bottom-right-radius: 100px;\r\n    background-image: linear-gradient(to right, #b0d4fb 0%, #819df6 51%, #78b4ec 100%);\r\n    background-size: 200% auto;\r\n    color: white;\r\n    width: 20%;\r\n    margin-left: 10px;\r\n\r\n    padding: 8px;\r\n}\r\n\r\n.endDayBtn{\r\n    padding: 10px;\r\n    border-radius: 100px;\r\n    margin: 20px;\r\n    width: 200px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border: 1px solid #3145f2;\r\n    background-color: #eaf0ff;\r\n    color: #3145f2;\r\n    font-size: 12pt;\r\n    font-weight: 600;\r\n}\r\n\r\n\r\n\r\n\r\n.anotherButtons {\r\n    box-shadow: -3px 2px 0px 0px #e85656;\r\n    width: 50px;\r\n    height: 50px;\r\n    border-radius: 12px;\r\n    background-color: rgb(255 245 245);\r\n    border: none;\r\n    font-weight: 600;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n    transition-duration: 0.3s;\r\n    overflow: hidden;\r\n    position: relative;\r\n    margin: 10px;\r\n    color: red;\r\n}\r\n\r\n.svgIcon {\r\n    width: 12px;\r\n    transition-duration: 0.3s;\r\n}\r\n\r\n.svgIcon path {\r\n    fill: rgb(255, 16, 16);\r\n}\r\n\r\n.anotherButtons:hover {\r\n    width: 140px;\r\n    border-radius: 12px;\r\n    transition-duration: 0.3s;\r\n    background-color: rgb(255, 0, 0);\r\n    align-items: center;\r\n    color: white;\r\n    box-shadow: none;\r\n\r\n}\r\n\r\n.anotherButtons:hover .svgIcon {\r\n    /* width: 20px; */\r\n    transition-duration: 0.3s;\r\n    transform: translateY(-200%);\r\n}\r\n\r\n.addPatientManual::before {\r\n    position: absolute;\r\n    bottom: -20px;\r\n    content: \"הוספת מטופל\";\r\n    color: white;\r\n    font-size: 0px;\r\n}\r\n\r\n\r\n.anotherButtons:hover::before {\r\n    font-size: 13px;\r\n    opacity: 1;\r\n    bottom: unset;\r\n    transition-duration: 0.3s;\r\n}\r\n.no-patients-message{\r\n    margin: 20px;\r\n    background-color: white;\r\n    box-shadow: 3px 2px 9px 0px rgb(222 222 222);\r\n    padding: 20px;\r\n    border-radius: 20px;\r\n    display: flex;\r\n    align-items: center;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
